/**
 * External Imports
 */
import { FC } from 'react';
import { scaleBand, scaleLinear, ScaleBand, ScaleLinear } from 'd3-scale';
/**
 * Internal Imports
 */
import Bar from './BarChart';

interface MetricsData {
  totalRecordsCount: number;
  metrics: { label: string; value: number; color: string }[];
}

interface TransitionalBarChartProps {
  metricsData: MetricsData;
}

const TransitionalBarChart: FC<TransitionalBarChartProps> = ({
  metricsData
}) => {
  const parentWidth = 300;
  const margin = {
    top: 10,
    right: 0,
    bottom: 30,
    left: 50
  };

  // settings totalRecordsCount to -1 if it is 0 to avoid issues with scaling
  const totalRecordsCount =
    metricsData.totalRecordsCount === 0 ? -1 : metricsData.totalRecordsCount;

  const width = parentWidth - margin.left - margin.right;
  const height = parentWidth * 0.75 - margin.top - margin.bottom;

  const xScale: ScaleBand<string> = scaleBand<string>()
    .domain(metricsData.metrics.map(metric => metric.label))
    .range([0, width]);

  const yScale: ScaleLinear<number, number> = scaleLinear()
    .domain([0, totalRecordsCount])
    .range([height, 0]);

  return (
    <svg
      width={width + margin.left + margin.right}
      height={height + margin.top + margin.bottom}
      style={{ paddingLeft: metricsData.metrics.length > 2 ? '0px' : '15px' }}
    >
      <g transform={`translate(${margin.left}, ${margin.top})`}>
        <Bar
          xScale={xScale}
          yScale={yScale}
          data={metricsData.metrics}
          height={height}
        />
      </g>
    </svg>
  );
};

export default TransitionalBarChart;
